import { CommissionValue } from "../../../constants/types";
import {
  calculateCommission,
  calculateFareWithCommission,
} from "../../../constants/helper";
import { useGlobalState } from "../../../services/context/AuthContext";

type FlightDetailPriceSummaryProps = {
  travellersDetail?: any;
  otherCharges?: any;
  discountAmount?: number;
  commissionAmount?: number;
};

const FlightDetailPriceSummary = ({
  travellersDetail,
  otherCharges,
  discountAmount,
  commissionAmount,
}: FlightDetailPriceSummaryProps) => {
  const { userInfo } = useGlobalState();
  const afterCommissionAdultFare =
    travellersDetail?.adultFare * travellersDetail?.adultCount;

  const afterCommissionChildFare =
    travellersDetail?.childFare * travellersDetail?.childrenCount;

  const afterCommissionInfantFare =
    travellersDetail?.infantFare * travellersDetail?.infantCount;

  const baseTotal =
    afterCommissionAdultFare +
    afterCommissionChildFare +
    afterCommissionInfantFare;

  const tax = travellersDetail?.totalTax ?? 0;
  const extras = otherCharges?.grandTotal ?? 0;
  const discount = discountAmount ?? 0;

  const grandTotal =
    Math.round(baseTotal + tax + extras - discount) + (commissionAmount ?? 0);
  const currency = userInfo?.currencyCode || "AED";

  return (
    <>
      <div className="">
        <div className="card mb-3 mt-5">
          <div className="card-header card-head-bg">
            Fare Summary
            <div className="prc-h2 ng-binding">
              {" "}
              <i className="fa-solid fa-person pe-1"></i>
              {travellersDetail?.adultCount ?? 0}
            </div>
            <div className="prc-h3 ng-binding">
              <i className="fa-solid fa-child pe-1"></i>
              {travellersDetail?.childrenCount ?? 0}
            </div>
            <div className="prc-h4 ng-binding">
              <i className="fa-solid fa-child-reaching pe-1"></i>
              {travellersDetail?.infantCount ?? 0}
            </div>
          </div>
          <div className="">
            <div className="pr ng-scope">
              {travellersDetail?.adultCount !== 0 && (
                <>
                  <div className="pr-l ng-binding">
                    Adult x {travellersDetail?.adultCount}
                  </div>

                  <div className="fsumritcl">
                    <span className="ng-binding">
                      {currency} {Math.round(afterCommissionAdultFare)}
                    </span>
                  </div>
                </>
              )}
            </div>

            {travellersDetail?.childrenCount !== 0 && (
              <div className="pr ng-scope">
                <div className="pr-l ng-binding">
                  Children x {travellersDetail?.childrenCount}
                </div>

                <div className="fsumritcl">
                  <span className="ng-binding">
                    {currency} {Math.round(afterCommissionChildFare)}
                  </span>
                </div>
              </div>
            )}

            {travellersDetail?.infantCount !== 0 && (
              <>
                <div className="pr ng-scope">
                  <div className="pr-l ng-binding">
                    Infant x {travellersDetail?.infantCount}
                  </div>

                  <div className="fsumritcl">
                    <span className="ng-binding">
                      {currency} {Math.round(afterCommissionInfantFare)}
                    </span>
                  </div>
                </div>
              </>
            )}

            {!!discountAmount && (
              <div className="pr ng-scope">
                <div className="pr-l-n pt-1">Discount</div>
                <div className="fsumritcl">
                  <i className="CurrncyCD_Rs" />
                  <span className="ng-binding">{currency} {discountAmount}</span>
                </div>
              </div>
            )}

            <div className="pr ng-scope">
              <div className="pr-l-n pt-1">Total Taxes</div>
              <div className="fsumritcl">
                <i className="CurrncyCD_Rs" />
                <span className="ng-binding">
                  {currency} {travellersDetail?.totalTax}
                </span>
              </div>
            </div>
            {!!otherCharges?.baggage && (
              <div className="pr ng-scope">
                <div className="pr-l-n">Baggage</div>
                <div className="fsumritcl">
                  <i className="CurrncyCD_Rs" />
                  <span className="ng-binding">
                    {currency} {otherCharges?.baggage}
                  </span>
                </div>
              </div>
            )}
            {!!otherCharges?.meal && (
              <div className="pr ng-scope">
                <div className="pr-l-n">Meal</div>
                <div className="fsumritcl">
                  <i className="CurrncyCD_Rs" />
                  <span className="ng-binding">{currency} {otherCharges?.meal}</span>
                </div>
              </div>
            )}
            {!!otherCharges?.seat && (
              <div className="pr ng-scope">
                <div className="pr-l-n">Seat</div>
                <div className="fsumritcl">
                  <i className="CurrncyCD_Rs" />
                  <span className="ng-binding">{currency} {otherCharges?.seat}</span>
                </div>
              </div>
            )}
            {!!commissionAmount && (
              <div className="pr ng-scope">
                <div className="pr-l-n">Other Charges</div>
                <div className="fsumritcl">
                  <i className="CurrncyCD_Rs" />
                  <span className="ng-binding">{currency} {commissionAmount}</span>
                </div>
              </div>
            )}
            <div className="pr py-2">
              <div className="pr-l1">Grand Total</div>
              <div className="frettlsum">
                <i className="CurrncyCD_Rs" />
                <span className="ng-binding">{currency} {Math.round(grandTotal)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlightDetailPriceSummary;
